import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { routerActions } from 'react-router-redux'

import EventCard from './Card'
import {List, ListItem} from 'material-ui/List'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead, currentDate } from 'selectors/common'
import { propertiesEx } from 'selectors/properties'
import { getMonth, getTimezoneDate } from 'utils/date'

const filters = {
	"Inbox": false
  , "Timeline": false
  , "Comments": false
  , "Repairs": "Task"
}

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesEx(state)[props.propertyID]
	  , currentDate: currentDate(state)
	})
)

export class VendorList extends Component {
	render() {
		let { props } = this
		let filter = filters[props.tabSelected]
		let events = R.filter((event=>(event.type==filter || !filter)), props.events)
	    return(
			<div>
				<List
					style={{
						backgroundColor: "transparent"
						, paddingTop: "0"
					}}
				>
					{events && R.map(event => <EventCard event={event} currentDate={props.currentDate} lineColor={filter=="Task" && "grey"} />, events || [])}
					{/*props.events &&
						R.map(month=>R.map(event => <EventCard event={event} currentDate={props.currentDate} />, props.events[month] || []), this.state.months || [])
					*/}
				</List>
			</div>
	    )
	}
}
export default connect(select, R.mergeAll([dataActions, routerActions]))(VendorList)



// WEBPACK FOOTER //
// ./src/components/Communication/events/List.js